import React from 'react';
import { StatTab } from 'component-library';

export const CustomTab = ({ tab }) => {
  return (
    <StatTab value={tab.id} label={tab.name} secondaryLabel="-" url={tab.url} />
  );
};
